<!-- 添加房间表单 -->
<template>
    <el-dialog title="新增" :visible.sync="visible" width="50%" :before-close="handleCloseDialog">
        <el-form :model="form" ref="formData" class="demo-form-inline" label-width="90px" style="width:400px;margin:0 auto;">
            <el-form-item label="房间名称" 
                prop="housename"
                :rules="{
                    required: true, message: '房间名称不能为空', trigger: 'blur'
                }">
                <el-input v-model="form.housename" placeholder="请输入房间名称"></el-input>
            </el-form-item>
            <el-form-item label="房间面积"
                prop="area"
                :rules="{
                    required: true, message: '房间面积不能为空', trigger: 'blur'
                }">
                <el-input-number v-model="form.area" controls-position="right" :precision="2" :step="1"></el-input-number>&nbsp;&nbsp;m²
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="form.description" placeholder="请输入备注"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
export default {
    name:  'CmpHouseForm',
    props: ["visible", "moduleidlist", "formData"],
    data() {
        return {
            form: {

            }
        };
    },

    watch: {
        formData() {
            // console.log('addForm变化');
            this.handleInitData();
        }
    },
    mounted() {
        this.handleInitData()
    },

    methods: {
        // 初始化数据
        handleInitData() {
            this.form = Object.assign({},this.formData);

        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", false);
            this.resetForm('formData');
        },
        // 保存表单
        handleSave() {
            this.$refs['formData'].validate(async valid => {
                if (valid) {
                    let params = this.getParams();
                    let data
                    if(params.oid){
                        // 修改
                        data = await Service.editHouse(params);
                    }else{
                        // 新增
                        data = await Service.addHouse(params);
                    }
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                            duration: 1500,
                        });
                        this.$emit("handleCloseDialog", true);
                        this.resetForm('formData');
                    }
                } else {
                    return false;
                }
            })
        },
        // 重置表单
        resetForm(formname) {
            this.$refs[formname].resetFields();
            this.$nextTick(() => {
                
            });
        },
        // 添加参数
        getParams() {
            let {housename,description,oid,area} = this.form;
            let obj = Object.assign({}, {moduleidlist: this.moduleidlist}, {housename,description,oid,area})
            return obj;
        }
    }
}

</script>
<style lang='less' scoped>

</style>